/* Bookly V81: Overstyr trigger for desktop sticky ATC (pro_sticky_atc)
   Mål: sticky skal dukke opp idet original buybox begynner å gå under sticky header.
   Gjelder kun produktsider og kun fra sm breakpoint (>= 576px).

   Ekstra: Synk max/totalqty på sticky antall når man bytter variant i stickybaren.
*/

(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
      return;
    }
    document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    var body = document.body;
    if (!body || !body.classList || !body.classList.contains('template-product')) {
      return;
    }

    var mql = window.matchMedia('(min-width: 576px)');
    var header = document.querySelector('.header-area');
    var marker = document.querySelector('.sticky__pro_button') || document.querySelector('.bookly-buybox .pro-details-quality');

    if (!header || !marker) {
      return;
    }

    var offsetPx = 8;

    function updateStickyClass() {
      if (!mql.matches) {
        body.classList.remove('atc_sticky_scoll');
        return;
      }

      var headerRect = header.getBoundingClientRect();
      var markerRect = marker.getBoundingClientRect();
      var threshold = headerRect.bottom + offsetPx;

      if (markerRect.top <= threshold) {
        body.classList.add('atc_sticky_scoll');
      } else {
        body.classList.remove('atc_sticky_scoll');
      }
    }

    // Synk max/totalqty ved variantbytte i sticky.
    var stickyQtyInput = document.querySelector('.pro_sticky_atc input.bookly-sticky-qty-input');
    var stickyVariantRoot = document.querySelector('.pro_sticky_atc .pro_variant__options');

    function normalizeMax(v) {
      var n = parseInt(v, 10);
      if (!Number.isFinite(n) || n <= 0) return 9999;
      return n;
    }

    function applyMaxToSticky(maxVal) {
      if (!stickyQtyInput) return;
      var maxN = normalizeMax(maxVal);
      stickyQtyInput.setAttribute('max', String(maxN));
      stickyQtyInput.setAttribute('totalqty', String(maxN));
      stickyQtyInput.dataset.max = String(maxN);
      stickyQtyInput.dataset.quantity = String(maxN);

      var cur = parseInt(stickyQtyInput.value, 10);
      if (!Number.isFinite(cur) || cur < 1) cur = 1;
      if (cur > maxN) {
        stickyQtyInput.value = String(maxN);
      }
    }

    if (stickyVariantRoot) {
      stickyVariantRoot.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('a[data-quantity]') : null;
        if (!a) return;
        applyMaxToSticky(a.getAttribute('data-quantity'));
      });
    }

    updateStickyClass();
    window.addEventListener('scroll', updateStickyClass, { passive: true });
    window.addEventListener('resize', updateStickyClass);
  });
})();
